import { IconEventAccount } from './Account';
import { IconEventBookTransfer } from './BookTransfer';
import { IconEventCheck } from './Check';
import { IconEventIdentity } from './Identity';
import { IconEventIncoming } from './Incoming';
import { IconEventLoan } from './Loan';
import { IconEventOutgoing } from './Outgoing';
import { IconEventReport } from './Report';
export const IconEvent = {
    Account: IconEventAccount,
    BookTransfer: IconEventBookTransfer,
    Check: IconEventCheck,
    Identity: IconEventIdentity,
    Incoming: IconEventIncoming,
    Loan: IconEventLoan,
    Outgoing: IconEventOutgoing,
    Report: IconEventReport,
};
//# sourceMappingURL=index.js.map